module.exports = __webpack_public_path__ + "img/order-step7-b.fe6fc714.png";